 /* eslint-disable */
import gsap from 'gsap';
import barba from '@barba/core';

// Default Animation instance
const animation = (target, animation) => {
    const timeline = gsap.timeline();
    timeline
        .to(target, 1, animation)

    const controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '.module--gallery',
        duration: 1000,
        triggerHook: 1,
    }).setTween(timeline).addTo(controller);
}

// Animation group function
const galleryAnimation = (item, itemAnimation, shapeAnimation) => {
    animation('.gallery__item-' + item, itemAnimation);
    animation('.gallery__item-' + item +' .gallery__item__shape', shapeAnimation);
}

$(document).ready( function() {
    if (screen.width > 766) {
        galleryAnimation(0, { y: -50 }, { y: -225, x: 25 });
        galleryAnimation(1, { y: 0 }, { y: 0, x: 40 });
        galleryAnimation(2, { y: -50 }, { y: 225 });
        animation('.gallery__text', { x: -100 });
    }
});

barba.hooks.after(() => {
    if (screen.width > 766) {
        galleryAnimation(0, { y: -50 }, { y: -225, x: 25 });
        galleryAnimation(1, { y: 0 }, { y: 0, x: 40 });
        galleryAnimation(2, { y: -50 }, { y: 225 });
    }

    animation('.gallery__text', { x: -100 });
});

/* eslint-enable */
